import { Paper, Stack, useTheme } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { ProfileMedicationsContent } from 'src/sections/@dashboard/profile/components/ProfileMedicationsContent';

export default function ProfileTabsMedicationsPage() {
  const theme = useTheme();

  return (
    <>
      <Helmet>
        <title>Lekarstwa | Vetsi</title>
      </Helmet>

      <Paper
        sx={{
          borderRadius: 2,
          boxShadow: theme.customShadows.z8,
          height: 1,
        }}
      >
        <Stack sx={{ height: 1, minHeight: '560px' }}>
          <ProfileMedicationsContent />
        </Stack>
      </Paper>
    </>
  );
}
